import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12.739 13.636c-.408.302-1.07.302-1.477 0L4.616 8.727c-.408-.301-.408-.79 0-1.09l6.646-4.91c.407-.301 1.069-.301 1.477 0l6.646 4.91c.407.3.407.789 0 1.09zm-2.954 1.091c1.223.904 3.207.904 4.43 0l6.647-4.909c1.223-.904 1.223-2.369 0-3.273l-6.646-4.909c-1.224-.903-3.208-.903-4.431 0l-6.646 4.91c-1.224.903-1.224 2.368 0 3.272zM12 21.5c-.277 0-.543-.082-.738-.226l-6.646-4.91c-.196-.144-.306-.34-.306-.545 0-.204.11-.4.306-.545l.738-.546c.408-.301.408-.79 0-1.09-.408-.302-1.069-.302-1.477 0l-.738.545c-.588.434-.918 1.022-.918 1.636s.33 1.203.918 1.636l6.646 4.91c.587.434 1.384.677 2.215.677s1.628-.243 2.216-.677l6.646-4.91c.587-.433.917-1.022.917-1.636s-.33-1.202-.917-1.636l-.739-.546c-.408-.3-1.069-.3-1.477 0-.408.302-.408.79 0 1.091l.739.546c.195.144.306.34.306.545s-.11.401-.306.546l-6.646 4.909a1.26 1.26 0 0 1-.739.226",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }